import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { initialTextTemplatesModalBasicFormVariablesAreaState, TextTemplatesModalBasicFormVariablesAreaState, TextTemplatesModalBasicFormVariablesAreaTypeOptions, TextTemplatesModalBasicFormVariablesAreaTypeSelection, VariableToEmit } from '@/modules/configurationModule/detail/templates/text-templates/components/text-templates-modal-basic-form-variables-area/text-templates-modal-basic-form-variables-area.models'
import { keys, map, uniq } from 'lodash'

@Component
export default class TextTemplatesModalBasicFormVariablesArea extends Vue {
    @Prop() readonly listVariables!: any
    @Emit()
    create(variable: any) {
        return variable
    }
    @Emit()
    update(variable: VariableToEmit) {
        return variable
    }
    @Emit()
    delete(variable: string) {
        return variable
    }
    @Emit()
    addTextToDescription(variable: string) {
        return variable
    }

    state: TextTemplatesModalBasicFormVariablesAreaState
    constructor() {
        super()
        this.state = initialTextTemplatesModalBasicFormVariablesAreaState()
    }

    get checkIfSimpleSelection(): boolean {
        return this.state.selectedVariable.typeSelected.value === TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION
    }

    get canRemoveItem(): boolean {
        return this.state.selectedVariable.values.length > 1
    }

    get canUpdateOrCreate(): boolean {
        return this.$_someFieldIsDirty(this.fields)
    }

    get existVariables() {
        return !!keys(this.listVariables)?.length
    }

    get hasNotDuplicates() {
        const values = map(this.state.selectedVariable.values, 'value')
        return uniq(values).length === values.length
    }

    get canCreateVariable() {
        const idValidated = !!this.state.selectedVariable.id
        const hasErrors = !!this.errors.count()
        const simpleSelectionValidated = this.state.selectedVariable.typeSelected.value === TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION && !!this.state.selectedVariable.values.length && !hasErrors
        switch (this.state.selectedVariable.typeSelected.value) {
        case TextTemplatesModalBasicFormVariablesAreaTypeSelection.FREE_TEXT:
            return this.canUpdateOrCreate && idValidated
        case TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION:
            return this.canUpdateOrCreate && idValidated && simpleSelectionValidated && this.hasNotDuplicates
        default:
            return this.canUpdateOrCreate && idValidated
        }
    }

    addVariable() {
        this.state = {
            ...initialTextTemplatesModalBasicFormVariablesAreaState(),
            viewMode: false,
            editingVariable: false
        }
    }

    updateVariable(values: string[], key: string) {
        const parsedValues = values.map((value: string) => {
            return { value: value }
        })
        const selectedType = parsedValues.length ? this.findOptionType(TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION) : this.findOptionType(TextTemplatesModalBasicFormVariablesAreaTypeSelection.FREE_TEXT)
        this.state = {
            ...this.state,
            viewMode: false,
            editingVariable: true,
            editingVariableText: key,
            selectedVariable: {
                ...this.state.selectedVariable,
                id: key,
                values: parsedValues,
                typeSelected: selectedType
            }
        }
    }

    findOptionType(type: string) {
        return this.state.typeOptions.find((option: TextTemplatesModalBasicFormVariablesAreaTypeOptions) => option.value === type) || this.state.typeOptions[0]
    }

    changeToDefaultMode() {
        this.state = {
            ...this.state,
            viewMode: true,
            editingVariable: false
        }
    }

    addItemToSimpleSelectionList() {
        this.state.selectedVariable.values.push({ ...this.state.selectedOption })
    }

    deleteItemFromSimpleSelectionList(index: number) {
        this.state.selectedVariable.values.splice(index, 1)
    }

    changeType(selection:any) {
        switch (selection?.value) {
        case TextTemplatesModalBasicFormVariablesAreaTypeSelection.FREE_TEXT:
            break
        case TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION:
            this.setSimpleSelectionValues()
            break
        default:
            break
        }
    }

    setSimpleSelectionValues() {
        if (!this.state.selectedVariable.values.length) {
            this.addItemToSimpleSelectionList()
        }
    }

    async emitEventVariable() {
        const emitVariable: any = {}
        emitVariable[this.state.selectedVariable.id] = this.prepareOptionsValues()
        if (this.state.editingVariable) {
            this.update({ value: emitVariable, oldKey: this.state.editingVariableText, newKey: this.state.selectedVariable.id })
            this.changeToDefaultMode()
        } else {
            this.create(emitVariable)
            this.changeToDefaultMode()
        }
    }

    deleteEventVariable() {
        this.delete(this.state.selectedVariable.id)
        this.changeToDefaultMode()
    }

    isSimpleSelection() {
        return this.state.selectedVariable.typeSelected.value === TextTemplatesModalBasicFormVariablesAreaTypeSelection.SIMPLE_SELECTION
    }

    parseOptionsValues() {
        return map(this.state.selectedVariable.values, 'value')
    }

    prepareOptionsValues() {
        return this.isSimpleSelection() ? map(this.state.selectedVariable.values, 'value') : []
    }

    addToDescription(key: string) {
        this.addTextToDescription(key)
    }
}
